/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import * as REPORT_ACTION_TYPES from './types';

const INITIAL_STATE = {
  reportDataPayload: [],
  reportDataPayloadLoading: false,
  reportDataPayloadErrors: {},
  taxGroupList: [],
  taxGroupListLoading: false,
  taxGroupListErrors: {},

  reportModulesList: [],
  reportModulesListLoading: false,
  reportModulesListErrors: {},
  reportColumnsList: [],
  reportColumnsListLoading: false,
  reportColumnsListErrors: {},
  reportColumnsOperatorsList: [],
  reportColumnsOperatorsListLoading: false,
  reportColumnsOperatorsListErrors: {},
  generatedReportList: [],
  generatedReportListWithPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  generatedReportListLoading: false,
  generatedReportListErrors: {},
  // Save Report
  upsertReportLoading: false,
  upsertReportPayload: null,
  upsertReportErrors: {},
  // Export Report
  reportExportLoading: false,
  reportExportErrors: {},
  // Saved Reports List
  savedReportList: [],
  savedReportListLoading: false,
  savedReportListErrors: {},
  //delete report
  savedReportDeleteLoading: false,
  savedReportDeletePayload: [],
  savedReportDeleteErrors: {},
};

const reportReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case REPORT_ACTION_TYPES.REPORT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        reportDataPayloadLoading: false,
        reportDataPayload: [],
        reportDataPayloadErrors: {},
      });

    case REPORT_ACTION_TYPES.REPORT_GENERATE_REQUEST:
      return Object.assign({}, state, {
        reportDataPayloadLoading: true,
      });

    case REPORT_ACTION_TYPES.REPORT_GENERATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        reportDataPayloadLoading: false,
        reportDataPayload: action.data,
        reportDataPayloadErrors: {},
      });

    case REPORT_ACTION_TYPES.REPORT_GENERATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        reportDataPayloadLoading: false,
        reportDataPayloadErrors: action.error,
      });

    case REPORT_ACTION_TYPES.TAX_GROUP_LIST_REQUEST:
      return Object.assign({}, state, {
        taxGroupListLoading: true,
      });

    case REPORT_ACTION_TYPES.TAX_GROUP_LIST_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxGroupListLoading: false,
        taxGroupList: action.data,
        taxGroupListErrors: {},
      });

    case REPORT_ACTION_TYPES.TAX_GROUP_LIST_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxGroupListLoading: false,
        taxGroupListErrors: action.error,
      });

    case REPORT_ACTION_TYPES.REPORT_MODULE_FETCH_REQUEST:
      return Object.assign({}, state, {
        reportModulesListLoading: true,
      });
    case REPORT_ACTION_TYPES.REPORT_MODULE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        reportModulesList: action.data,
        reportModulesListLoading: false,
      });
    case REPORT_ACTION_TYPES.REPORT_MODULE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        reportModulesList: [],
        reportModulesListLoading: false,
        reportModulesListErrors: action.error,
      });
    case REPORT_ACTION_TYPES.REPORT_COLUMNS_FETCH_REQUEST:
      return Object.assign({}, state, {
        reportColumnsListLoading: true,
      });
    case REPORT_ACTION_TYPES.REPORT_COLUMNS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        reportColumnsList: action.data,
        reportColumnsListLoading: false,
      });
    case REPORT_ACTION_TYPES.REPORT_COLUMNS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        reportColumnsList: [],
        reportColumnsListLoading: false,
        reportColumnsListErrors: action.error,
      });
    case REPORT_ACTION_TYPES.REPORT_COLUMNS_OPERATOR_FETCH_REQUEST:
      return Object.assign({}, state, {
        reportColumnsOperatorsListLoading: true,
      });
    case REPORT_ACTION_TYPES.REPORT_COLUMNS_OPERATOR_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        reportColumnsOperatorsList: action.data,
        reportColumnsOperatorsListLoading: false,
      });
    case REPORT_ACTION_TYPES.REPORT_COLUMNS_OPERATOR_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        reportColumnsOperatorsList: [],
        reportColumnsOperatorsListLoading: false,
        reportColumnsOperatorsListErrors: action.error,
      });
    case REPORT_ACTION_TYPES.REPORT_GENERATED_FETCH_REQUEST:
      return Object.assign({}, state, {
        generatedReportListLoading: true,
        generatedReportListErrors: {},
      });
    case REPORT_ACTION_TYPES.REPORT_GENERATED_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        generatedReportList: action.data,
        generatedReportListLoading: false,
        generatedReportListErrors: {},
        generatedReportListWithPagination: {
          current: action.data?.pageNumber,
          pageSize: action.data?.pageSize,
          total: action.data?.totalCount,
          totalPage: action.data?.totalCount
            ? Math.round(action.data?.totalCount / action.data?.pageSize) +
              (Math.abs(action.data?.totalCount / action.data.pageSize) >
              Math.round(action.data.totalCount / action.data.pageSize)
                ? 1
                : 0)
            : 0,
          showSizeChanger: true,
        },
      });
    case REPORT_ACTION_TYPES.REPORT_GENERATED_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        generatedReportList: [],
        generatedReportListLoading: false,
        generatedReportListErrors: action.error,
      });
    // Save Report
    case REPORT_ACTION_TYPES.REPORT_SAVE_REQUEST:
      return Object.assign({}, state, {
        upsertReportLoading: true,
      });
    case REPORT_ACTION_TYPES.REPORT_SAVE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        upsertReportLoading: false,
        upsertReportPayload: action.data,
      });
    case REPORT_ACTION_TYPES.REPORT_SAVE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        upsertReportLoading: false,
        upsertReportErrors: action.error,
      });
    // Export Report
    case REPORT_ACTION_TYPES.REPORT_EXPORT_REQUEST:
      return Object.assign({}, state, {
        reportExportLoading: true,
      });
    case REPORT_ACTION_TYPES.REPORT_EXPORT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        reportExportLoading: false,
      });
    case REPORT_ACTION_TYPES.REPORT_EXPORT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        reportExportLoading: false,
        reportExportErrors: action.error,
      });
    // Saved Report List
    case REPORT_ACTION_TYPES.SAVED_REPORT_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        savedReportListLoading: true,
        savedReportListErrors: {},
      });
    case REPORT_ACTION_TYPES.SAVED_REPORT_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        savedReportListLoading: false,
        savedReportList: action.data,
      });

    case REPORT_ACTION_TYPES.SAVED_REPORT_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        savedReportListLoading: false,
        savedReportListErrors: action.error,
      });
    case REPORT_ACTION_TYPES.SAVED_REPORT_RESET:
      return Object.assign({}, state, {
        savedReportId: null,
      });
    case REPORT_ACTION_TYPES.SAVED_REPORT_DELETE_REQUEST:
      return Object.assign({}, state, {
        savedReportDeleteLoading: true,
      });
    case REPORT_ACTION_TYPES.SAVED_REPORT_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        savedReportDeleteLoading: false,
        savedReportDeletePayload: action.data,
      });
    case REPORT_ACTION_TYPES.SAVED_REPORT_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        savedReportDeleteLoading: false,
        savedReportDeleteErrors: action.error,
      });

    default:
      return state;
  }
};

export default reportReducer;
